import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { resetJourney } from '@/store/reset';
import { DEFAULT_COUNTRY } from '@/locale';
import { TransactionFetchData } from '@/api/payments/fetchTransaction';

export interface UserDetailsState {
  firstName: string,
  lastName: string,
  email: string,
  confirmEmail: string,
  jobTitle: string,
  organisationName: string,
  establishmentType: string,
  establishmentName: string,
  address1: string,
  address2: string,
  address3: string,
  town: string,
  postcode: string,
  country: string,
}

const initialState: Readonly<UserDetailsState> = {
  firstName: (import.meta.env.VITE_DEV_FILL_FIRSTNAME ?? ''),
  lastName: (import.meta.env.VITE_DEV_FILL_LASTNAME ?? ''),
  email: (import.meta.env.VITE_DEV_FILL_EMAIL ?? ''),
  confirmEmail: '',
  jobTitle: '',
  establishmentType: '',
  organisationName: '',
  establishmentName: '',
  address1: '',
  address2: '',
  address3: '',
  town: '',
  postcode: '',
  country: DEFAULT_COUNTRY,
};

export const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    updateUserDetailsFields(state: UserDetailsState, action: PayloadAction<Partial<UserDetailsState>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setUserDetailsFromTransactionData(state: UserDetailsState, action: PayloadAction<TransactionFetchData>) {
      return {
        ...state,
        email: action.payload.email,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        address1: action.payload.address1,
        address2: action.payload.address2 ?? '',
        address3: action.payload.address3 ?? '',
        town: action.payload.town,
        postcode: action.payload.postcode,
        country: action.payload.country,
      };
    },
  },
  extraReducers: builder => builder.addCase(resetJourney, () => initialState),
});

export const {
  updateUserDetailsFields,
  setUserDetailsFromTransactionData,
} = userDetailsSlice.actions;
